import { httpsCallable, getFunctions } from "firebase/functions";
import { app } from "./firebaseService";

export type SyncCampPhotoUrlsResult = {
  ok: boolean;
  propagated: boolean;
  reason?: string;
};

/**
 * Re-run Storage→Firestore URL propagation for one campPhotos doc (after upload; handles finalize race).
 */
export async function syncCampPhotoUrlsAfterUpload(campPhotoId: string): Promise<SyncCampPhotoUrlsResult> {
  const functions = getFunctions(app, "us-east4");
  const call = httpsCallable<{ campPhotoId: string }, SyncCampPhotoUrlsResult>(functions, "syncCampPhotoUrls");
  const res = await call({ campPhotoId });
  return res.data;
}
